import React, { useState } from "react";

const getShortFormat = (value, shortDecimals = 0) => {
  if (value < 1) return value.toString(); 
  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(shortDecimals)}M`;
  if (value >= 1_000) return `${(value / 1_000).toFixed(shortDecimals)}K`;
  return Number(value).toFixed(shortDecimals);
};

const formatNumber = (value, decimals = 2) =>
  Number(value).toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

export default function ToggleNumber({ value = 0, suffix = '', decimals = 2 ,shortDecimals = 0,}){
    const[isShort, setIsShort] = useState(true);
    const handleClick = () => setIsShort((prev) => !prev);
    const displayVal = isShort  ? `${getShortFormat(value, shortDecimals)}${suffix}`
    : `${formatNumber(value, decimals)}${suffix}`;
        
    return(
        <span
        onClick={handleClick}
        style={{cursor:'pointer',fontWeight:'500'}}
        title="click to toggle format"
        >
            {displayVal}
        </span>
    );
}